import React from 'react';
import { Input } from './styles';

export default function Find() {
  return <Input type="text" placeholder="Pesquisar" />;
}
